import React from 'react';
import { useFela } from '../..';
import { WithTheme } from '../../Theme';
import { WithDmId } from '../../utils/BaseProps';

export type TextWeight = 'bold' | 'normal';
export type TextKind = 'error' | 'default';
export type TextSize = 'small' | 'medium';

export type TextProps = WithDmId & {
  /**
   * String oder Komponente, die übergeben werden kann, um ein
   * anderes Element mit den Eigenschaften von Text zu rendern.
   */
  as?: string | JSX.Element | Function;
  /**
   * String oder Object, für den darzustellenden Text.
   */
  children: object | string;
  /**
   * String, mit dem die Schriftstärke gewählt werden kann.
   */
  weight?: TextWeight;
  /**
   * String, mit dem die Ausprägung des Textes gewählt werden kann.
   */
  kind?: TextKind;
  /**
   * String, mit dem die Schriftgröße gewählt werden kann.
   */
  size?: TextSize;
  /**
   * Optional kann das Styling des Textes überschrieben werden.
   * Davon darf nur im Ausnahmefall Gebrauch gemacht werden!
   */
  style?: object;
  [otherProp: string]: any;
};

const defaultStyle = ({
  theme,
  weight,
  kind,
  size,
}: WithTheme<Pick<TextProps, 'weight' | 'kind' | 'size'>>) => ({
  fontFamily: theme.typography.fontFamily.primary.main,
  fontWeight: 400,
  lineHeight: theme.typography.lineHeight.m.value,
  color: theme.palette.color3.hex,
  margin: 0,

  extend: [
    {
      condition: weight === 'bold',
      style: {
        fontWeight: 700,
      },
    },
    {
      condition: kind === 'error',
      style: {
        color: theme.palette.color8.hex,
      },
    },
    {
      condition: size === 'small',
      style: {
        fontSize: theme.typography.fontSize.s.rem,
        lineHeight: theme.typography.lineHeight.s.value,
      },
    },
  ],
});

export default function Text({
  as = 'p',
  children,
  kind = 'default',
  weight = 'normal',
  size = 'medium',
  style = {},
  dmId = 'dm-text',
  ...otherProps
}: TextProps): JSX.Element {
  const { css } = useFela({ kind, weight, size });
  const Component = as;
  return (
    // @ts-ignore
    <Component
      data-designsystem
      data-dmid={dmId}
      className={css([defaultStyle, style])}
      {...otherProps}>
      {children}
    </Component>
  );
}
